import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { AnimatePresence, motion } from 'framer-motion';
export function Appointment() {
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 5000);
  };
  return <section id="appointment" className="py-32 md:py-48 relative" data-id="element-11">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12" data-id="element-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 lg:gap-32" data-id="element-13">
          <FadeIn data-id="element-14">
            <div className="flex flex-col h-full justify-center" data-id="element-15">
              <h2 className="serif text-4xl md:text-5xl text-charcoal mb-8" data-id="element-16">
                פגישה אישית
              </h2>
              <p className="text-charcoal/60 font-light text-lg mb-16 max-w-md" data-id="element-17">
                אנו מזמינים אתכם לחוות את הקולקציות שלנו מקרוב, או להתחיל מסע
                משותף לעיצוב תכשיט בהתאמה אישית.
              </p>

              <div className="space-y-8" data-id="element-18">
                <div data-id="element-19">
                  <h4 className="label-tiny text-charcoal/50 mb-2" data-id="element-20">כתובת</h4>
                  <p className="text-charcoal font-light" data-id="element-21">
                    שדרות רוטשילד 1, תל אביב
                  </p>
                </div>
                <div data-id="element-22">
                  <h4 className="label-tiny text-charcoal/50 mb-2" data-id="element-23">
                    שעות פעילות
                  </h4>
                  <p className="text-charcoal font-light" data-id="element-24">
                    א׳-ה׳: 10:00 - 18:00
                    <br data-id="element-25" />
                    בתיאום מראש בלבד
                  </p>
                </div>
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-26">
            <div className="bg-white/50 p-10 md:p-16 relative" data-id="element-27">
              <form onSubmit={handleSubmit} className="flex flex-col gap-12" data-id="element-28">
                <div className="relative" data-id="element-29">
                  <input type="text" required className="w-full bg-transparent border-b border-charcoal/20 py-4 text-charcoal focus:outline-none focus:border-gold transition-colors duration-500 peer placeholder-transparent" placeholder="שם מלא" id="name" data-id="element-30" />
                  <label htmlFor="name" className="absolute right-0 top-4 label-tiny text-charcoal/50 peer-focus:-translate-y-6 peer-focus:text-gold peer-focus:text-[10px] peer-valid:-translate-y-6 peer-valid:text-[10px] transition-all duration-300 pointer-events-none" data-id="element-31">
                    שם מלא
                  </label>
                </div>

                <div className="relative" data-id="element-32">
                  <input type="tel" required className="w-full bg-transparent border-b border-charcoal/20 py-4 text-charcoal focus:outline-none focus:border-gold transition-colors duration-500 peer placeholder-transparent" placeholder="טלפון" id="phone" data-id="element-33" />
                  <label htmlFor="phone" className="absolute right-0 top-4 label-tiny text-charcoal/50 peer-focus:-translate-y-6 peer-focus:text-gold peer-focus:text-[10px] peer-valid:-translate-y-6 peer-valid:text-[10px] transition-all duration-300 pointer-events-none" data-id="element-34">
                    טלפון
                  </label>
                </div>

                <div className="relative" data-id="element-35">
                  <input type="date" className="w-full bg-transparent border-b border-charcoal/20 py-4 text-charcoal focus:outline-none focus:border-gold transition-colors duration-500 peer placeholder-transparent" id="date" data-id="element-36" />
                  <label htmlFor="date" className="absolute right-0 -top-2 label-tiny text-charcoal/50 transition-all duration-300 pointer-events-none" data-id="element-37">
                    תאריך מועדף
                  </label>
                </div>

                <button type="submit" className="mt-4 group relative inline-flex items-center justify-center px-10 py-4 border border-charcoal/20 hover:border-gold transition-colors duration-700 overflow-hidden self-start" data-id="element-38">
                  <span className="relative z-10 label-tiny text-charcoal group-hover:text-gold transition-colors duration-700" data-id="element-39">
                    תיאום פגישה
                  </span>
                  <div className="absolute inset-0 bg-gold/5 translate-y-full group-hover:translate-y-0 transition-transform duration-700 ease-[0.16,1,0.3,1]" data-id="element-40" />
                </button>
              </form>

              <AnimatePresence data-id="element-41">
                {submitted && <motion.div initial={{
                opacity: 0,
                y: 10
              }} animate={{
                opacity: 1,
                y: 0
              }} exit={{
                opacity: 0
              }} className="absolute bottom-10 left-10 right-10 bg-charcoal text-ivory p-4 text-center" data-id="element-42">
                    <span className="label-tiny" data-id="element-43">
                      תודה. ניצור עמכם קשר בקרוב.
                    </span>
                  </motion.div>}
              </AnimatePresence>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}